import { render, staticRenderFns } from "./SignUpComponent.vue?vue&type=template&id=6c9e6ab8&scoped=true"
import script from "./SignUpComponent.vue?vue&type=script&lang=js"
export * from "./SignUpComponent.vue?vue&type=script&lang=js"
import style0 from "./SignUpComponent.vue?vue&type=style&index=0&id=6c9e6ab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9e6ab8",
  null
  
)

export default component.exports